<template>
  <div class="News" id="News">
    <v-app>
      <v-app-bar app color='primary' dark height="564" absolute>
        <v-row align="start">
          <!-- 一级导航栏 -->
          <FirstNavbar :pc='pc' :tab_index="first_active_tab" :barHide="barHide" :barColor="barColor"></FirstNavbar>
          <div class='first_title_box'  style="width:100%;height:calc(564px - 64px);" >
            <v-row align="center" justify="center">
              <v-col cols="12">
                <h1 class="first_title white--text">
                  生态文明科学实验基地
                </h1>
                <h4 class="body_text white--text">
                  <span>诚信</span><span>规范</span><span>创新</span><span>高效</span>
                </h4>
              </v-col>
            </v-row>
          </div>
          <!-- 首屏大图 -->
          <div style="width:100%;height:500px;position:absolute;z-index:-3;margin-left:-4px">
            <v-parallax height="564" dark src="../assets/images/生态基地顶部.png">
            </v-parallax>
          </div>
        </v-row>
      </v-app-bar>
      <v-main>
        <div class="aboutContent">
          <v-row dense>
            <v-col cols="12">
              <BoxTitle firstTitle="生态文明科学实验基地" :index="1"></BoxTitle>
              <div class='content'>
                <p class='body_text'>地理位置：河北省保定市定兴县城北（雄安新区容城县西部毗邻区），坐标北纬39°18´38"，东经115°47´3"，海拔30米</p>
                <div class="imgBox">
                  <img src='../assets/images/生态基地.png'>
                </div>
                <p class='body_text'>发展定位：雄安新区国际领先水平的现代地理综合研究超级站卫星站。</p>
                <div class="imgBox">
                  <img src='../assets/images/生态基地3.jpg'>
                </div>
                <h2 class='title'>主要研究内容：</h2>
                <p class='body_text'>在国内首次系统开展白洋淀上游雄安新区关键生态枢纽带的快速城市化过程中农田、人工林土地覆被变化及其对水循环、氮磷循环、大气二氧化碳和PM2.5等污染物的影响的长期观测研究，探索定兴县“六位一体”生态文明建设模式、“六城建设”生态城，为雄安新区及毗邻地区生态环境建设和绿色低碳发展提供科学依据。</p>
                <div class="imgBox">
                  <img src='../assets/images/生态基地4.png'>
                </div>
                <h2 class='title'>观测系统：</h2>
                <p class='body_text'>40米高（基座2米×2米）综合观测塔、生态数据中心及135亩人工林地等。</p>
                <p class="body_text">植被-大气水气通量观测系统;</p>
                <p class="body_text">土壤-植被水分、养分传输观测系统;</p>
                <p class="body_text">快速城市化过程人类活动-植被、土壤、大气二氧化碳、PM2.5等颗粒物通量观测系统。</p>
                <div class="imgBox">
                  <img src='../assets/images/生态基地5.png'>
                </div>
                <div class="imgBox">
                  <img src='../assets/images/生态基地6.png'>
                </div>
                <div class="imgBox">
                  <img src='../assets/images/生态基地7.png'>
                </div>
                <h2 class='title'>主要观测内容和观测指标：</h2>
                <div class="imgBox">
                  <img src='../assets/images/生态基地2.png'>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-main>
      <v-footer  color="secondary" style="height:auto">
        <FootContent :active="footList.active" :listWidth="footList.listWidth"></FootContent>
      </v-footer>
    </v-app>
  </div>
</template>

<script>
import FootContent from '../components/footer.vue'
import FirstNavbar from '../components/first-navbar.vue'
import BoxTitle from '../components/box-title.vue'

export default {
  name: 'yuanqu',

  components: {
    FootContent,
    FirstNavbar,
    BoxTitle
  },
  data: () => ({
    // 导航背景颜色
    barColor: 'rgba(63, 81, 181,0)',
    // 导航栏是否隐藏
    barHide: true,
    // 悬浮按钮是否隐藏
    floatHidden: true,
    // 一级导航选项卡
    first_active_tab: 0,
    // 是否为PC端
    pc: false,
    // 页脚参数
    footList: {
      listWidth: '10rem',
      active: [true, true, true]
    },
    contentHtml: ''
  }),
  created () {
    this.$nextTick(() => {
    })
  },
  mounted () {
    this.goTo(0)
    var that = this
    that.whatScreen()
    // 屏幕尺寸监听
    window.onresize = function () {
      that.whatScreen()
    }
  },
  methods: {
    // 屏幕
    whatScreen () {
      var width = document.querySelector('html').offsetWidth
      if (width <= 768) {
        // title.innerHTML = "极小屏幕-" + width
        this.footList.active = [false, false, false]
        this.footList.listWidth = '90rem'
        this.pc = false
      } else {
        if (width > 768 && width <= 992) {
          // title.innerHTML = "小屏幕-" + width
          this.footList.active = [true, true, true]
          this.footList.listWidth = '10rem'
          this.pc = false
        } else {
          if (width > 992 && width <= 1100) {
            // title.innerHTML = "普通屏幕-" + width
            this.footList.active = [true, true, true]
            this.footList.listWidth = '10rem'
            this.pc = true
          } else {
            if (width > 1200 && width <= 1600) {
              // title.innerHTML = "大屏幕-" + width
              this.footList.active = [true, true, true]
              this.footList.listWidth = '10rem'
              this.pc = true
            } else {
              if (width > 1600) {
                // title.innerHTML = "大屏幕-" + width
                this.footList.listWidth = '10rem'
                this.footList.active = [true, true, true]
                this.pc = true
              }
            }
          }
        }
      }
    },
    // 一级导航跳转定位
    toguid (path_, id) {
      const path = path_
      const Id = id
      localStorage.setItem('toId', Id)
      this.$router.push(path)
    },
    goTo (ele) {
      document.body.scrollTop = ele
      document.documentElement.scrollTop = ele
    }
  }

}
</script>

<style scoped>
.content .title{
    font-size: 2.3rem;
    line-height: 3.6rem;
    margin-bottom:1rem;
    color:var(--fontColor)
}
.content .subtitle{
    font-size: 1.05rem;
    line-height: 1.5rem;
    margin-bottom: 1rem;
    font-weight: 400;
    text-indent:1.15rem;
    color:var(--fontColor)
}
.content > p{
    text-indent: 2.3rem;
}
.content > .imgBox{
    width:100%;
    position:relative;
    display:flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
}
.content > .imgBox > img{
    height:23rem;
    margin:1rem;
}
</style>
